import { render, staticRenderFns } from "./NTreeTable.vue?vue&type=template&id=10a4cb12"
import script from "./NTreeTable.vue?vue&type=script&lang=js"
export * from "./NTreeTable.vue?vue&type=script&lang=js"
import style0 from "./NTreeTable.vue?vue&type=style&index=0&id=10a4cb12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports